//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import middleService from "@/services/middleService";
import { mapState } from "vuex";

import Compressor from "compressorjs";
import OSS from "ali-oss";
import Storage from "@/utils/storage";
import { getQueryValue } from "@/utils/index";
import { isMobile } from "@/utils/is";
import "apower-ui/lib/theme-chalk/icon.css";

import { Select, Option, Input, InputNumber } from "apower-ui";
const components = [Select, Option, Input, InputNumber];

components.forEach((component) => {
  Vue.component(component.name, component);
});

var myimage = new Image();
myimage.setAttribute("crossOrigin", "anonymous");
var calWidth, calHeight;
var tempCrop;
var wh; //裁剪框的最大最小宽高

var transX, transY; //canvas偏移
var cropTempObj,
  cropLeft = 0,
  cropTop = 0; //裁剪框无变化时终止
var resizeWRatio = 1,
  resizeHRatio = 1;
export default {
  name: "picwishDemo",
  componentName: "picwishDemo",
  props: {
    submittext: {
      type: String,
      default: "Log in",
    },
  },
  // components: {
  //   Select,
  //   Input,
  //   InputNumber
  // },
  data() {
    return {
      linkTo: "",
      client: null,
      zoomLevel: 1,
      undoOperate: false,
      redoOperate: false,
      currentTool: "bigger",
      appStatus: "", // 'uploading', 'uploaded', 'editing', 'processing', 'finished'
      selectedFile: null,

      uploaded: 0,
      uploadQueue: [],
      currentUploadQueue: [],
      fileList: [],
      showOption: true,
      times: 2,
      compress: 1,
      compressFormat: "",

      cropOptions: [
        {
          value: "free",
          label: this.$t("mesage.free"),
        },
        {
          value: "1",
          label: this.$t("mesage.1"),
        },
        {
          value: 9 / 16,
          label: this.$t("mesage.916"),
        },
        {
          value: 2 / 3,
          label: this.$t("mesage.23"),
        },
        {
          value: 4 / 3,
          label: this.$t("mesage.43"),
        },
        {
          value: 16 / 9,
          label: this.$t("mesage.169"),
        },
        {
          value: 210 / 297,
          label: this.$t("mesage.a4"),
        },
        {
          value: 11 / 17,
          label: this.$t("mesage.poster"),
        },
        {
          value: 2 / 2,
          label: this.$t("mesage.passport"),
        },
        {
          value: 1200 / 628,
          label: this.$t("mesage.facebook"),
        },
        {
          value: 9,
          label: this.$t("mesage.instagram"),
        },
        {
          value: 16,
          label: this.$t("mesage.youTube"),
        },
      ],
      cropValue: "free",
      lockRatio: 1,
      resizeWidth: 1,
      resizeHeight: 1,
      lock: true,
      cropWidth: 20,
      cropHeight: 20,
      padding: 10,
      operation: null,
      previousEvent: null,
      resizeTarget: null,
      mouseDownX: 0,
      mouseDownY: 0,
      mousePressed: false,
      isblue: false,
      isCropResize: false, //经过裁剪尺寸调整后下载要转换
      imgfixBefore: true,
      pagefrom: "reAddFile",
      maxLimit: false,
      modalMsg: "",
      beforeSize: "", //移动端压缩前后对比
      afterSize: "",
      isMobile: isMobile,
      imgInfo: null, //历史记录1
    };
  },
  computed: {
    isCompress() {
      return getQueryValue("type") === "compress" && this.isMobile;
    },
    ...mapState({
      identityToken: (state) => state.user?.identityToken,
      userInfo: (state) => state.user?.userInfo,
    }),
    isLogined() {
      return this.identityToken && this.userInfo;
    },
  },
  async created() {
    let link = window.location.pathname.substring(
      0,
      window.location.pathname.lastIndexOf("/")
    );
    if (link) {
      this.linkTo = link;
    }
    let file = Storage.get("imgInfo");
    this.imgInfo = Storage.get("imgInfo"); //history1
    if (file && window.location.pathname.indexOf("edit-photo") > -1) {
      await this.selectFile(file);
      this.beforeSize = file.size;
    }
    let type = getQueryValue("type");
    if (type && type != "enlarger") {
      this.chooseTool(type);
    }

    const lang = document.documentElement.lang || "en";
    if (lang == "es") {
      let tempOptions = [
        {
          value: "free",
          label: this.$t("mesage.free"),
        },
        {
          value: "1",
          label: "1x1",
        },
        {
          value: 9 / 16,
          label: "9x16",
        },
        {
          value: 16 / 9,
          label: "16x9",
        },
        {
          value: 4 / 5,
          label: "4x5",
        },
        {
          value: 4 / 3,
          label: "4x3",
        },
        {
          value: 2 / 1,
          label: "2x1",
        },
        {
          value: 5 / 3,
          label: "5x3",
        },
        {
          value: 3 / 2,
          label: "3x2",
        },
        {
          value: 3 / 4,
          label: "3x4",
        },
        {
          value: 16,
          label: "YouTube Thumbnail(1280 x 720 px)",
        },
        {
          value: 1200 / 628,
          label: "Facebook(1200 x 628 px)",
        },
        {
          value: 9,
          label: "Instagram Story(1080 x 1920 px)",
        },
      ];
      this.cropOptions = tempOptions;
    }
    if (lang == "fr") {
      let tempOptions = [
        {
          value: "free",
          label: this.$t("mesage.free"),
        },
        {
          value: "1",
          label: "1:1",
        },
        {
          value: 4 / 3,
          label: "4:3",
        },
        {
          value: 3 / 4,
          label: "3:4",
        },
        {
          value: 9 / 16,
          label: "9:16",
        },
        {
          value: 1920 / 1080,
          label: "Présentation(1920*1080px)",
        },
        {
          value: 35 / 45,
          label: "Montage photo(35*45mm)",
        },
        {
          value: 2480 / 3508,
          label: "CV(2480*3508px)",
        },
        {
          value: 42 / 59.4,
          label: "Affiche(42*59.4cm)",
        },
        {
          value: 500 / 500,
          label: "Logo(500*500px)",
        },
        {
          value: 21,
          label: "Document A4(21*29.7cm)",
        },
        {
          value: 8,
          label: "Publication instagram(1080*1080px)",
        },
        {
          value: 16,
          label: "YouTube(1280*720px)",
        },
      ];
      this.cropOptions = tempOptions;
    }
    if (lang == "ja") {
      let tempOptions = [
        {
          value: "free",
          label: this.$t("mesage.free"),
        },
        {
          value: "1",
          label: "1:1",
        },
        {
          value: 16 / 9,
          label: "16:9",
        },
        {
          value: 9 / 16,
          label: "9:16",
        },
        {
          value: 3 / 4,
          label: "3:4",
        },
        {
          value: 4 / 3,
          label: "4:3",
        },
        {
          value: 560,
          label: "履歴書(40mm × 30mm)",
        },
        {
          value: 413 / 531,
          label: "パスポート(45mm x 35mm)",
        },
        {
          value: 531,
          label: "マイナンバー(45mm x 35mm)",
        },
        {
          value: 368 / 460,
          label: "運転免許証(30mm x 24mm)",
        },
      ];
      this.cropOptions = tempOptions;
    }
    if (lang == "zh") {
      let tempOptions = [
        {
          value: "free",
          label: this.$t("mesage.free"),
        },
        {
          value: "1",
          label: "1:1",
        },
        {
          value: 16 / 9,
          label: "16:9",
        },
        {
          value: 9 / 16,
          label: "9:16",
        },
        {
          value: 3 / 4,
          label: "3:4",
        },
        {
          value: 4 / 3,
          label: "4:3",
        },
        {
          value: 259 / 377,
          label: this.$t("mesage.inch1"),
        },
        {
          value: 295 / 413,
          label: this.$t("mesage.inch2"),
        },
        {
          value: 413 / 531,
          label: this.$t("mesage.inch3"),
        },
        {
          value: 413 / 579,
          label: this.$t("mesage.inch4"),
        },
      ];
      this.cropOptions = tempOptions;
    }
  },
  async mounted() {},
  methods: {
    refreshAccess: async function (filename) {
      let postData = {
        task_type: 111,
        filenames: [filename],
      };
      const res = await middleService
        .post("/authorizations/oss", postData)
        .catch((err) => {
          console.log(err);
          window.setTimeout(() => {
            this.refreshAccess(filename);
          }, 3000);
        });
      if (res.data.status === 200) {
        const authentications = res.data.data;
        Storage.set("authentications", authentications);
        this.saveData(
          "expires_in",
          authentications.expires_in,
          authentications.expires_in - 60 * 2
        );
        this.client = new OSS({
          region: authentications.region,
          accessKeyId: authentications.credential.access_key_id,
          accessKeySecret: authentications.credential.access_key_secret,
          stsToken: authentications.credential.security_token,
          bucket: authentications.bucket,
          secure: true,
          endpoint:
            document.documentElement.lang === "zh"
              ? authentications.endpoint
              : authentications.accelerate,
        });
        return authentications;
      } else {
        console.log(res.data);
      }
    },
    /**
     * @param {*} key  [保存数据的key]
     * @param {*} value [保存数据的值]
     * @param {*} expires [过期的时间，单位：秒]
     */
    saveData(key, value, expires) {
      if (!value) {
        Storage.remove(key);
      } else {
        Storage.set(key, {
          value,
          expires: new Date().getTime() + expires * 1000,
        });
      }
    },

    // 获取保存的数据
    getData(key) {
      try {
        const data = Storage.get(key);
        if (!data || data.expires < Date.now()) {
          return null;
        } else {
          return data.value;
        }
      } catch (e) {
        console.log(e);
        return null;
      }
    },

    showAccountDialog() {
      const { showAccountDialog } = useService("AccountService");
      showAccountDialog();
    },

    addFile: function (type, reAddFile) {
      if (reAddFile == "reAddFile") {
        // 清空当前队列
        this.uploadQueue = [];
        this.fileList = [];
      }
      this.pagefrom = reAddFile;
      this.$refs.addFileInput.click();
    },

    onAddFileChange: async function (e, type) {
      this.uploaded = 0;
      var files = [];
      for (let i = 0; i < this.$refs.addFileInput.files.length; i++) {
        files.push(this.$refs.addFileInput.files[i]);
      }

      !!e && !!type && (this.pagefrom = type);
      !!e && files.push(e);
      console.log(files);
      this.$refs.addFileInput.files = null;
      this.$refs.addFileInput.value = "";

      this.currentUploadQueue = [];
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 20 * 1024 * 1024) {
          this.modalMsg = this.$t("mesage.imageSize20");
          this.maxLimit = true;
          return false;
        }
        this.currentUploadQueue.push(files[i]);
      }

      // 批量上传

      // this.$parent.currentRouter = "afterUpload";
      this.appStatus = "uploading";

      for (let i = 0; i < files.length; i++) {
        this.beforeSize = files[i].size;
        // let pressFile = await this.compressFile(files[i])
        this.fileList.push(
          Object.assign(files[i], {
            status: "uploading",
            progress: 0,
          })
        );
        this.uploadSingleFile(this.fileList[this.fileList.length - 1]);
      }
      // document.getElementById("ap-header").style.display = "none";
      // document.getElementsByTagName("footer")[0].style.display = "none";
    },

    compressFile(file, width, height) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.8,
          width: width,
          height: height,
          success(result) {
            resolve(result);
          },
          error(err) {
            console.log(err.message);
            reject(err.message);
          },
        });
      });
    },
    getFileNameUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    // 上传单个文件
    uploadSingleFile: async function (file) {
      let authentications = await this.refreshAccess(file.name);
      let key = authentications.objects[file.name];
      file["key"] = key;
      this.uploadQueue.push({
        name: file.name,
        resource_id: null,
        task_id: null,
        upload_progress: 0, //上传进度
        process_progress: 0, // 处理进度
        query_interval: null,
        processed_url: null,
        key: key,
        status: "uploading",
        url: null,
        type: null,
        width: null,
        height: null,
        canvasRatio: 1,
        size: this.beforeSize,
        extension: file.name.substring(file.name.lastIndexOf(".") + 1),
        historyArray: [],
        hStep: -1,
        brushPath: [],
        points: [],
        rectangles: [],
        cropangles: null,
        touched: false, // 是否已操作过
      });
      let url = authentications["callback"]["url"];
      let callbackBody = authentications["callback"]["body"];
      let callback = {
        url: url,
        body:
          callbackBody +
          "&filename=" +
          encodeURI(file.name) +
          "&x:object=" +
          key +
          "&x:endpoint=" +
          authentications.endpoint +
          "&x:bucket=" +
          authentications.bucket,
      };

      this.client
        .multipartUpload(key, file, {
          cancelFlag: true,
          callback: callback,
          partSize: 500 * 1024,
          headers: {
            "Content-Disposition": encodeURI(file.name),
          },
        })
        .then(
          function (res) {
            if (res.data.status === 200) {
              var key = res.name;
              let index;
              for (let i = 0; i < this.uploadQueue.length; i++) {
                if (this.uploadQueue[i]["key"] === key) {
                  index = i;
                }
              }

              if (index > -1) {
                this.isblue = false;
                this.afterSize = 0;

                this.uploadQueue[index]["upload_progress"] = 1;
                this.uploadQueue[index]["status"] = "uploaded";
                this.uploadQueue[index]["url"] = res.data.data.url;
                this.uploadQueue[index]["width"] =
                  res.data.data.file_info.width;
                this.uploadQueue[index]["height"] =
                  res.data.data.file_info.height;
                this.uploadQueue[index]["resource_id"] =
                  res.data.data.resource_id;
                this.uploaded++;
                if (this.uploaded === this.currentUploadQueue.length) {
                  this.imgInfo = JSON.parse(
                    JSON.stringify(this.uploadQueue[index])
                  );
                  Storage.set(
                    "imgInfo",
                    JSON.parse(JSON.stringify(this.imgInfo))
                  );
                  // Storage.set("pagefrom", this.pagefrom);
                  if (this.pagefrom == "reAddFile") {
                    this.selectFile(this.uploadQueue[index]);
                  } else {
                    this.appStatus = "uploaded";
                    window.location.href =
                      this.linkTo + "/edit-photo?type=" + this.pagefrom;
                  }
                }
              }
            }
          }.bind(this)
        )
        .catch((err) => {
          console.log(err);
          this.appStatus = "";
          this.modalMsg = this.$t("mesage.uploadError");
          this.maxLimit = true;
        });
    },

    selectFile: function (file) {
      if (file.status === "uploading") {
        return false;
      }
      this.selectedFile = file;
      // this.appStatus = 'editing';
      file.touched = true;
      this.$nextTick(
        function () {
          this.refreshCanvas();
        }.bind(this)
      );
    },
    initCanvas(elementWidth, elementHeight, changeUrl) {
      let container = this.$refs["preview-wrapper"];
      let containerWidth = container.clientWidth;
      let containerHeight = container.clientHeight;

      if (elementWidth < containerWidth && elementHeight < containerHeight) {
        calWidth = elementWidth;
        calHeight = elementHeight;
      } else {
        if (containerWidth / containerHeight >= elementWidth / elementHeight) {
          calWidth = Math.round(
            (containerHeight / elementHeight) * elementWidth
          );
          calHeight = containerHeight;
        } else {
          calWidth = containerWidth;
          calHeight = Math.round(
            (containerWidth / elementWidth) * elementHeight
          );
        }
      }

      let canvas = this.$refs["canvas"];
      canvas.setAttribute("width", calWidth);
      canvas.setAttribute("height", calHeight);
      let upperCanvas = this.$refs["upper-canvas"];
      upperCanvas.setAttribute("width", calWidth);
      upperCanvas.setAttribute("height", calHeight);
      this.$refs["item"].style.width = calWidth + "px";
      this.$refs["item"].style.height = calHeight + "px";
      this.selectedFile.canvasRatio = calWidth / this.selectedFile.width;
      // imgInfo.cropRatio = this.selectedFile.canvasRatio

      this.resizeWidth = elementWidth;
      this.resizeHeight = elementHeight;

      this.zoomLevel = 1;
      this.setTransform(this.zoomLevel, 0, 0, false);

      this.cropValue = "free";
      this.lock = true;
      this.cropWidth = elementWidth;
      this.cropHeight = elementHeight;
      this.lockRatio = this.cropWidth / this.cropHeight;
      wh = this.getWH(this.lockRatio);
      if (!this.selectedFile.cropangles) {
        this.selectedFile.cropangles = {
          x: 0,
          y: 0,
          width: this.selectedFile.width * this.selectedFile.canvasRatio,
          height: this.selectedFile.height * this.selectedFile.canvasRatio,
        };
      } else {
        this.selectedFile.cropangles.x = 0;
        this.selectedFile.cropangles.y = 0;
        this.selectedFile.cropangles.width =
          this.selectedFile.width * this.selectedFile.canvasRatio;
        this.selectedFile.cropangles.height =
          this.selectedFile.height * this.selectedFile.canvasRatio;
      }

      if (myimage.src != this.selectedFile.url) {
        myimage.src = this.selectedFile.url; //减少加载
        cropLeft = 0;
        cropTop = 0;
        // cropRatio = this.selectedFile.canvasRatio
        cropTempObj = JSON.parse(JSON.stringify(this.selectedFile.cropangles));
        cropTempObj.width = elementWidth;
        cropTempObj.height = elementHeight;
      }
      if (changeUrl) {
        cropLeft = 0;
        cropTop = 0;
        // cropRatio = this.selectedFile.canvasRatio
        cropTempObj = JSON.parse(JSON.stringify(this.selectedFile.cropangles));
        cropTempObj.width = elementWidth;
        cropTempObj.height = elementHeight;
      }
    },
    refreshCanvas: function () {
      // 计算canvas的宽高和位置
      this.initCanvas(this.selectedFile.width, this.selectedFile.height);

      this.zoomLevel = 1;
      if (this.selectedFile.hStep > 0) {
        this.undoOperate = true;
      } else {
        this.undoOperate = false;
      }
      if (this.selectedFile.hStep < this.selectedFile.historyArray.length - 1) {
        this.redoOperate = true;
      } else {
        this.redoOperate = false;
      }

      this.reDraw();
    },
    reDraw() {
      let canvas = document.getElementById("canvas");
      if (canvas) {
        let context = canvas.getContext("2d");

        // 清空画布
        context.clearRect(0, 0, calWidth, calHeight);
        if (this.currentTool == "crop") {
          //蒙版
          context.save();
          context.fillStyle = "rgba(0,0,0,0.5)";
          context.fillRect(0, 0, calWidth, calHeight);
          context.globalCompositeOperation = "source-atop";
          context.restore();
          //画裁剪框
          context.save();
          context.clearRect(
            this.selectedFile.cropangles.x,
            this.selectedFile.cropangles.y,
            this.selectedFile.cropangles.width,
            this.selectedFile.cropangles.height
          );
          this.drawCrop(this.selectedFile.cropangles);
          context.restore();
        }
        if (myimage.complete) {
          // 如果图片已经存在于浏览器缓存
          // myimage.onload = function () {
          //   console.log("myimage.complete")
          // }
          context.save();
          context.globalCompositeOperation = "destination-over";
          context.drawImage(
            myimage,
            cropLeft,
            cropTop,
            cropTempObj.width,
            cropTempObj.height,
            0,
            0,
            calWidth,
            calHeight
          );
          context.restore();
          return;
        }
        myimage.onload = () => {
          context.save();
          context.globalCompositeOperation = "destination-over";
          context.drawImage(
            myimage,
            cropLeft,
            cropTop,
            cropTempObj.width,
            cropTempObj.height,
            0,
            0,
            calWidth,
            calHeight
          );
          context.restore();
          myimage.onload = null;
          this.appStatus = "editing";
        };
      }
    },
    drawCrop: function (rectangle) {
      let canvas = document.getElementById("canvas");
      let context = canvas.getContext("2d");
      context.lineWidth = 2;
      context.strokeStyle = "white";
      context.beginPath();
      context.moveTo(rectangle.x, rectangle.y);
      context.lineTo(rectangle.x + rectangle.width, rectangle.y);
      context.lineTo(
        rectangle.x + rectangle.width,
        rectangle.y + rectangle.height
      );
      context.lineTo(rectangle.x, rectangle.y + rectangle.height);
      context.lineTo(rectangle.x, rectangle.y);
      context.stroke();

      context.lineWidth = 1;
      context.strokeStyle = "rgba(255, 255, 255, 0.5)";
      context.beginPath();
      context.moveTo(rectangle.x + rectangle.width / 3, rectangle.y);
      context.lineTo(
        rectangle.x + rectangle.width / 3,
        rectangle.y + rectangle.height
      );
      context.stroke();

      context.beginPath();
      context.moveTo(rectangle.x + (rectangle.width / 3) * 2, rectangle.y);
      context.lineTo(
        rectangle.x + (rectangle.width / 3) * 2,
        rectangle.y + rectangle.height
      );
      context.stroke();

      context.beginPath();
      context.moveTo(rectangle.x, rectangle.y + rectangle.height / 3);
      context.lineTo(
        rectangle.x + rectangle.width,
        rectangle.y + rectangle.height / 3
      );
      context.stroke();
      context.beginPath();
      context.moveTo(rectangle.x, rectangle.y + (rectangle.height / 3) * 2);
      context.lineTo(
        rectangle.x + rectangle.width,
        rectangle.y + (rectangle.height / 3) * 2
      );
      context.stroke();
      //8个点
      context.strokeStyle = "rgba(153, 153, 153, 1)";
      context.fillStyle = "#FFFFFF";
      context.beginPath();
      context.rect(rectangle.x - 3, rectangle.y - 3, 8, 8);
      context.stroke();
      context.fill();

      context.beginPath();
      context.rect(
        rectangle.x + rectangle.width / 2 - 4,
        rectangle.y - 3,
        8,
        8
      );
      context.stroke();
      context.fill();

      context.beginPath();
      context.rect(rectangle.x + rectangle.width - 5, rectangle.y - 3, 8, 8);
      context.stroke();
      context.fill();

      context.beginPath();
      context.rect(
        rectangle.x + rectangle.width - 5,
        rectangle.y + rectangle.height / 2 - 4,
        8,
        8
      );
      context.stroke();
      context.fill();

      context.beginPath();
      context.rect(
        rectangle.x + rectangle.width - 5,
        rectangle.y + rectangle.height - 5,
        8,
        8
      );
      context.stroke();
      context.fill();

      context.beginPath();
      context.rect(
        rectangle.x + rectangle.width / 2 - 4,
        rectangle.y + rectangle.height - 5,
        8,
        8
      );
      context.stroke();
      context.fill();

      context.beginPath();
      context.rect(rectangle.x - 3, rectangle.y + rectangle.height - 5, 8, 8);
      context.stroke();
      context.fill();

      context.beginPath();
      context.rect(
        rectangle.x - 3,
        rectangle.y + rectangle.height / 2 - 4,
        8,
        8
      );
      context.stroke();
      context.fill();
    },
    checkClickInsideRectangle: function (rectangle, click) {
      return (
        click.x > rectangle.x &&
        click.x < rectangle.x + rectangle.width &&
        click.y > rectangle.y &&
        click.y < rectangle.y + rectangle.height
      );
    },

    checkClickIsResizeRectangle: function (rectangle, click) {
      if (
        this.distance(
          {
            x: rectangle.x,
            y: rectangle.y,
          },
          click
        ) < this.padding
      ) {
        return "tl";
      } else if (
        this.distance(
          {
            x: rectangle.x + rectangle.width,
            y: rectangle.y,
          },
          click
        ) < this.padding
      ) {
        return "tr";
      } else if (
        this.distance(
          {
            x: rectangle.x + rectangle.width / 2,
            y: rectangle.y + rectangle.height,
          },
          click
        ) < this.padding
      ) {
        return "cb";
      } else if (
        this.distance(
          {
            x: rectangle.x + rectangle.width / 2,
            y: rectangle.y,
          },
          click
        ) < this.padding
      ) {
        return "ct";
      } else if (
        this.distance(
          {
            x: rectangle.x,
            y: rectangle.y + rectangle.height / 2,
          },
          click
        ) < this.padding
      ) {
        return "cl";
      } else if (
        this.distance(
          {
            x: rectangle.x + rectangle.width,
            y: rectangle.y + rectangle.height / 2,
          },
          click
        ) < this.padding
      ) {
        return "cr";
      } else if (
        this.distance(
          {
            x: rectangle.x,
            y: rectangle.y + rectangle.height,
          },
          click
        ) < this.padding
      ) {
        return "bl";
      } else if (
        this.distance(
          {
            x: rectangle.x + rectangle.width,
            y: rectangle.y + rectangle.height,
          },
          click
        ) < this.padding
      ) {
        return "br";
      } else {
        return false;
      }
    },

    distance: function (coordA, coordB) {
      return Math.sqrt(
        (coordA.x - coordB.x) * (coordA.x - coordB.x) +
          (coordA.y - coordB.y) * (coordA.y - coordB.y)
      );
    },
    onMouseDown: function (event) {
      tempCrop = JSON.parse(JSON.stringify(this.selectedFile.cropangles));
      this.mouseDownX = event.clientX;
      this.mouseDownY = event.clientY;
      this.mousePressed = true;
      if (this.currentTool == "move") {
        this.$refs["preview-wrapper"].style.cursor = "grab";
        let str = this.$refs["item"].style.transform;
        if (str.indexOf("translate") > -1) {
          transX = parseFloat(
            str.substring(str.indexOf("translate(") + 10, str.indexOf("px"))
          );
          transY = parseFloat(
            str.substring(str.indexOf("px,") + 4, str.indexOf("px)"))
          );
        }
      }
      if (this.currentTool == "crop") {
        let cropangles = this.selectedFile.cropangles;
        if (
          (this.resizeTarget = this.checkClickIsResizeRectangle(cropangles, {
            x: event.offsetX,
            y: event.offsetY,
          }))
        ) {
          this.operation = "resizing";
          this.$refs["canvas"].style.cursor = "pointer";
        } else if (
          this.checkClickInsideRectangle(cropangles, {
            x: event.offsetX,
            y: event.offsetY,
          })
        ) {
          this.operation = "moving";
        }
      }
    },
    onMouseMove: function (event) {
      if (this.currentTool == "crop") {
        let cropangles = this.selectedFile.cropangles;
        if (
          this.checkClickIsResizeRectangle(cropangles, {
            x: event.offsetX,
            y: event.offsetY,
          })
        ) {
          this.$refs["canvas"].style.cursor = "pointer";
        } else {
          this.$refs["canvas"].style.cursor = "unset";
        }
      }
      if (this.mousePressed) {
        let movementX, movementY; //, calX, calY
        movementX = (event.clientX - this.mouseDownX) / Number(this.zoomLevel);
        movementY = (event.clientY - this.mouseDownY) / Number(this.zoomLevel);

        if (this.currentTool == "move") {
          let moveX = movementX + transX;
          let moveY = movementY + transY;
          this.setTransform(this.zoomLevel, moveX, moveY, false);
        }
        if (this.currentTool == "crop") {
          if (this.operation === "moving") {
            if (tempCrop.x + movementX < 0) {
              this.selectedFile.cropangles.x = 0;
            } else if (tempCrop.x + movementX + tempCrop.width > calWidth) {
              this.selectedFile.cropangles.x = calWidth - tempCrop.width;
            } else {
              this.selectedFile.cropangles.x = tempCrop.x + movementX;
            }
            if (tempCrop.y + movementY < 0) {
              this.selectedFile.cropangles.y = 0;
            } else if (tempCrop.y + movementY + tempCrop.height > calHeight) {
              this.selectedFile.cropangles.y = calHeight - tempCrop.height;
            } else {
              this.selectedFile.cropangles.y = tempCrop.y + movementY;
            }
          } else if (this.operation === "resizing") {
            if (this.resizeTarget === "tl") {
              if (this.lock) {
                let height = tempCrop.height - movementY;
                let width = height * this.lockRatio;
                let x = tempCrop.x - width + tempCrop.width;
                let y = tempCrop.y + movementY;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x < 0 ||
                  y < 0
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.x = x;
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.x + movementX < 0) {
                  this.selectedFile.cropangles.x = 0;
                } else if (tempCrop.width - movementX < 20) {
                  this.selectedFile.cropangles.width = 20;
                } else {
                  this.selectedFile.cropangles.x = tempCrop.x + movementX;
                  this.selectedFile.cropangles.width =
                    tempCrop.width - movementX;
                }

                if (tempCrop.y + movementY < 0) {
                  this.selectedFile.cropangles.y = 0;
                } else if (tempCrop.height - movementY < 20) {
                  this.selectedFile.cropangles.height = 20;
                } else {
                  this.selectedFile.cropangles.y = tempCrop.y + movementY;
                  this.selectedFile.cropangles.height =
                    tempCrop.height - movementY;
                }
              }
            } else if (this.resizeTarget === "tr") {
              if (this.lock) {
                let height = tempCrop.height - movementY;
                let width = height * this.lockRatio;
                let x = tempCrop.x;
                let y = tempCrop.y + movementY;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x + width > calWidth ||
                  y < 0
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.width + movementX < 20) {
                  this.selectedFile.cropangles.width = 20;
                } else if (tempCrop.x + tempCrop.width + movementX > calWidth) {
                  this.selectedFile.cropangles.width = calWidth - tempCrop.x;
                } else {
                  this.selectedFile.cropangles.width =
                    tempCrop.width + movementX;
                }

                if (tempCrop.y + movementY < 0) {
                  this.selectedFile.cropangles.y = 0;
                } else if (tempCrop.height - movementY < 20) {
                  this.selectedFile.cropangles.height = 20;
                } else {
                  this.selectedFile.cropangles.y = tempCrop.y + movementY;
                  this.selectedFile.cropangles.height =
                    tempCrop.height - movementY;
                }
              }
            } else if (this.resizeTarget === "bl") {
              if (this.lock) {
                let height = tempCrop.height + movementY;
                let width = height * this.lockRatio;
                // let x = tempCrop.x + movementX
                let x = tempCrop.x - width + tempCrop.width;
                let y = tempCrop.y;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x < 0 ||
                  x + width > calWidth ||
                  y + height > calHeight
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.x = x;
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.x + movementX < 0) {
                  this.selectedFile.cropangles.x = 0;
                } else if (tempCrop.width - movementX < 20) {
                  this.selectedFile.cropangles.width = 20;
                } else {
                  this.selectedFile.cropangles.x = tempCrop.x + movementX;
                  this.selectedFile.cropangles.width =
                    tempCrop.width - movementX;
                }

                if (tempCrop.height + movementY < 20) {
                  this.selectedFile.cropangles.height = 20;
                } else if (
                  tempCrop.y + tempCrop.height + movementY >
                  calHeight
                ) {
                  this.selectedFile.cropangles.calHeight =
                    calHeight - tempCrop.y;
                } else {
                  this.selectedFile.cropangles.height =
                    tempCrop.height + movementY;
                }
              }
            } else if (this.resizeTarget === "br") {
              if (this.lock) {
                let height = tempCrop.height + movementY;
                let width = height * this.lockRatio;
                let x = tempCrop.x;
                let y = tempCrop.y;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x + width > calWidth ||
                  y + height > calHeight
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.x = x;
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.width + movementX < 20) {
                  this.selectedFile.cropangles.width = 20;
                } else if (tempCrop.x + tempCrop.width + movementX > calWidth) {
                  this.selectedFile.cropangles.width = calWidth - tempCrop.x;
                } else {
                  this.selectedFile.cropangles.width =
                    tempCrop.width + movementX;
                }

                if (tempCrop.height + movementY < 20) {
                  this.selectedFile.cropangles.height = 20;
                } else if (
                  tempCrop.y + tempCrop.height + movementY >
                  calHeight
                ) {
                  this.selectedFile.cropangles.calHeight =
                    calHeight - tempCrop.y;
                } else {
                  this.selectedFile.cropangles.height =
                    tempCrop.height + movementY;
                }
              }
            } else if (this.resizeTarget === "ct") {
              if (this.lock) {
                let height = tempCrop.height - movementY;
                let width = height * this.lockRatio;
                let x = tempCrop.x - (width - tempCrop.width) / 2;
                let y = tempCrop.y + movementY;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x < 0 ||
                  x + width > calWidth ||
                  y < 0
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.x = x;
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.y + movementY < 0) {
                  this.selectedFile.cropangles.y = 0;
                } else if (tempCrop.height - movementY < 20) {
                  this.selectedFile.cropangles.height = 20;
                } else {
                  this.selectedFile.cropangles.y = tempCrop.y + movementY;
                  this.selectedFile.cropangles.height =
                    tempCrop.height - movementY;
                }
              }
            } else if (this.resizeTarget === "cl") {
              if (this.lock) {
                let width = tempCrop.width - movementX;
                let height = width / this.lockRatio;
                let x = tempCrop.x + movementX;
                let y = tempCrop.y - (height - tempCrop.height) / 2;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x < 0 ||
                  y < 0 ||
                  y + height > calHeight
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.x = x;
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.x + movementX < 0) {
                  this.selectedFile.cropangles.x = 0;
                } else if (tempCrop.width - movementX < 20) {
                  this.selectedFile.cropangles.width = 20;
                } else {
                  this.selectedFile.cropangles.x = tempCrop.x + movementX;
                  this.selectedFile.cropangles.width =
                    tempCrop.width - movementX;
                }
              }
            } else if (this.resizeTarget === "cr") {
              if (this.lock) {
                let width = tempCrop.width + movementX;
                let height = width / this.lockRatio;
                let x = tempCrop.x;
                let y = tempCrop.y - (height - tempCrop.height) / 2;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x + width > calWidth ||
                  y < 0 ||
                  y + height > calHeight
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.x = x;
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.width + movementX < 20) {
                  this.selectedFile.cropangles.width = 20;
                } else if (tempCrop.x + tempCrop.width + movementX > calWidth) {
                  this.selectedFile.cropangles.width = calWidth - tempCrop.x;
                } else {
                  this.selectedFile.cropangles.width =
                    tempCrop.width + movementX;
                }
              }
            } else if (this.resizeTarget === "cb") {
              if (this.lock) {
                let height = tempCrop.height + movementY;
                let width = height * this.lockRatio;
                let x = tempCrop.x - (width - tempCrop.width) / 2;
                let y = tempCrop.y;
                if (
                  height > wh[1] ||
                  height < wh[3] ||
                  width > wh[0] ||
                  width < wh[2] ||
                  x < 0 ||
                  x + width > calWidth ||
                  y + height > calHeight
                ) {
                  return;
                } else {
                  this.selectedFile.cropangles.x = x;
                  this.selectedFile.cropangles.y = y;
                  this.selectedFile.cropangles.width = width;
                  this.selectedFile.cropangles.height = height;
                }
              } else {
                if (tempCrop.height + movementY < 20) {
                  this.selectedFile.cropangles.height = 20;
                } else if (
                  tempCrop.y + tempCrop.height + movementY >
                  calHeight
                ) {
                  this.selectedFile.cropangles.calHeight =
                    calHeight - tempCrop.y;
                } else {
                  this.selectedFile.cropangles.height =
                    tempCrop.height + movementY;
                }
              }
            }
            this.cropWidth = Math.round(
              this.selectedFile.cropangles.width / this.selectedFile.canvasRatio
            );
            this.cropHeight = Math.round(
              this.selectedFile.cropangles.height /
                this.selectedFile.canvasRatio
            );
          }
          this.previousEvent = event;
          this.reDraw();
          return false;
        }
      }
    },
    onMouseUp: function () {
      this.operation = null;
      this.mousePressed = false;
      this.$refs["canvas"].style.cursor = "unset";
    },
    onMouseLeave: function () {
      this.mousePressed = false;
      this.operation = null;
      this.$refs["canvas"].style.cursor = "unset";
    },
    wrapWheel: function (e) {
      let delta = 1;
      if (e.deltaY) {
        delta = e.deltaY > 0 ? 1 : -1;
      } else if (e.wheelDelta) {
        delta = -e.wheelDelta / 120;
      } else if (e.detail) {
        delta = e.detail > 0 ? 1 : -1;
      }
      let zoom = (Number(this.zoomLevel) + -delta * 0.1).toFixed(1);
      if (zoom > 0 && zoom < 4.1) {
        this.zoomLevel = zoom;
        this.setTransform(this.zoomLevel, 0, 0, true);
      }
    },
    backhome() {
      // document.getElementById("ap-header").style.display = "block";
      // document.getElementsByTagName("footer")[0].style.display = "block";
      // this.$parent.currentRouter = "beforeUpload";
      let type = getQueryValue("type");
      if (type) {
        if (type == "enlarger") {
          window.location.href = this.linkTo + "/image-enlarger";
        } else if (type == "crop") {
          window.location.href = this.linkTo + "/crop-image";
        } else if (type == "compress") {
          window.location.href = this.linkTo + "/compress-image";
        }
      } else {
        window.location.href = this.linkTo + "/";
      }
    },
    setTransform(zoomLevel, moveX, moveY, zoom) {
      if (zoom) {
        let translateX = 0,
          translateY = 0;
        let str = this.$refs["item"].style.transform;
        if (str.indexOf("translate") > -1) {
          translateX = parseFloat(
            str.substring(str.indexOf("translate(") + 10, str.indexOf("px"))
          );
          translateY = parseFloat(
            str.substring(str.indexOf("px,") + 4, str.indexOf("px)"))
          );
        }
        moveX = translateX;
        moveY = translateY;
      }
      this.$refs[
        "item"
      ].style.transform = `scale(${this.zoomLevel},${this.zoomLevel}) translate(${moveX}px,${moveY}px)`;

      let canvas = this.$refs["canvas"];
      canvas.style.transform = `scale(${this.zoomLevel},${this.zoomLevel}) translate(${moveX}px,${moveY}px)`;

      let upperCanvas = this.$refs["upper-canvas"];
      upperCanvas.style.transform = `scale(${this.zoomLevel},${this.zoomLevel}) translate(${moveX}px,${moveY}px)`;
    },
    zoomOut() {
      if (this.zoomLevel > 0.1) {
        this.zoomLevel = (this.zoomLevel - 0.1).toFixed(1);
        this.setTransform(this.zoomLevel, 0, 0, true);
      }
    },
    zoomIn() {
      if (this.zoomLevel < 4) {
        this.zoomLevel = (parseFloat(this.zoomLevel) + 0.1).toFixed(1);
        this.setTransform(this.zoomLevel, 0, 0, true);
      }
    },
    historyPush(type) {
      if (type == "crop-resize") {
        this.isCropResize = true;
      } else {
        this.isCropResize = false;
      }
      this.isblue = true;
      this.undoOperate = true;
      this.redoOperate = false;

      this.selectedFile.hStep++;
      if (this.selectedFile.hStep < this.selectedFile.historyArray.length) {
        this.selectedFile.historyArray.length = this.selectedFile.hStep;
      }
      // url: document.getElementById('canvas').toDataURL(),
      this.selectedFile.historyArray.push({
        width: this.selectedFile.width,
        height: this.selectedFile.height,
        url: this.selectedFile.url,
        size: this.selectedFile.size,
        extension: this.selectedFile.extension,
        cropTop: cropTop,
        cropLeft: cropLeft,
        cropTempObj: cropTempObj,
        isCropResize: this.isCropResize,
      });
    },
    undo() {
      if (this.selectedFile.hStep < 0) {
        return;
      } else if (this.selectedFile.hStep == 0) {
        this.isblue = false;
        this.undoOperate = false;
        this.redoOperate = true;
        this.selectedFile.hStep--;
        this.selectedFile.width = JSON.parse(
          JSON.stringify(this.imgInfo.width)
        );
        this.selectedFile.height = JSON.parse(
          JSON.stringify(this.imgInfo.height)
        );
        this.selectedFile.url = JSON.parse(JSON.stringify(this.imgInfo.url));
        this.selectedFile.size = JSON.parse(JSON.stringify(this.imgInfo.size));
        this.selectedFile.extension = JSON.parse(
          JSON.stringify(this.imgInfo.extension)
        );
        cropTop = 0;
        cropLeft = 0;
        // cropRatio=JSON.parse(JSON.stringify(imgInfo.cropRatio));
        cropTempObj.width = this.selectedFile.width;
        cropTempObj.height = this.selectedFile.height;
      } else if (this.selectedFile.hStep > 0) {
        this.undoOperate = true;
        this.redoOperate = true;
        this.selectedFile.hStep--;

        this.selectedFile.width = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].width
          )
        );
        this.selectedFile.height = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].height
          )
        );
        this.selectedFile.url = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].url
          )
        );
        this.selectedFile.size = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].size
          )
        );
        this.selectedFile.extension = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].extension
          )
        );
        cropTop = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].cropTop
          )
        );
        cropLeft = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].cropLeft
          )
        );
        // cropRatio = JSON.parse(JSON.stringify(this.selectedFile.historyArray[this.selectedFile.hStep].cropRatio));
        cropTempObj = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].cropTempObj
          )
        );
      }
      this.initCanvas(this.selectedFile.width, this.selectedFile.height);
      this.reDraw();
    },
    redo() {
      if (this.selectedFile.hStep < this.selectedFile.historyArray.length - 1) {
        this.isblue = true;
        this.undoOperate = true;
        this.redoOperate = true;
        this.selectedFile.hStep++;
        if (
          this.selectedFile.hStep ==
          this.selectedFile.historyArray.length - 1
        ) {
          this.redoOperate = false;
        }

        this.selectedFile.width = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].width
          )
        );
        this.selectedFile.height = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].height
          )
        );
        this.selectedFile.url = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].url
          )
        );
        this.selectedFile.size = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].size
          )
        );
        this.selectedFile.extension = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].extension
          )
        );
        cropTop = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].cropTop
          )
        );
        cropLeft = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].cropLeft
          )
        );
        // cropRatio = JSON.parse(JSON.stringify(this.selectedFile.historyArray[this.selectedFile.hStep].cropRatio));
        cropTempObj = JSON.parse(
          JSON.stringify(
            this.selectedFile.historyArray[this.selectedFile.hStep].cropTempObj
          )
        );

        this.initCanvas(this.selectedFile.width, this.selectedFile.height);
        this.reDraw();
      }
    },
    chooseTool(type) {
      if (this.currentTool == type) {
        this.showOption = !this.showOption;
      } else {
        this.showOption = true;
      }

      if (this.currentTool != "crop" && type == "crop") {
        this.cropValue = "free";
        this.lock = true;
        this.cropWidth = this.selectedFile.width;
        this.cropHeight = this.selectedFile.height;
        this.lockRatio = this.cropWidth / this.cropHeight;
        wh = this.getWH(this.lockRatio);
        this.selectedFile.cropangles.x = 0;
        this.selectedFile.cropangles.y = 0;
        this.selectedFile.cropangles.width =
          this.selectedFile.width * this.selectedFile.canvasRatio;
        this.selectedFile.cropangles.height =
          this.selectedFile.height * this.selectedFile.canvasRatio;
        if (this.zoomLevel != 1) {
          this.zoomLevel = 1;
          this.setTransform(this.zoomLevel, 0, 0, false);
        }
      }

      if (this.currentTool != "sizeless" && type == "sizeless") {
        this.lock = true;
        this.resizeWidth = this.selectedFile.width;
        this.resizeHeight = this.selectedFile.height;
        this.lockRatio = this.resizeWidth / this.resizeHeight;
      }

      if (
        (this.currentTool != "crop" && type == "crop") ||
        (this.currentTool == "crop" && type != "crop")
      ) {
        this.currentTool = type;
        this.reDraw(); //切换可以
      }

      this.currentTool = type;
    },
    closeOption() {
      this.showOption = false;
    },
    resizeWH(ratio) {
      let maxW, maxH, minW, minH;
      if (5120 * ratio > 5120) {
        maxW = Math.round(5120 * ratio);
        maxH = 5120;
      } else {
        maxW = 5120;
        maxH = Math.round(5120 / ratio);
      }

      if (1 * ratio > 1) {
        minW = Math.round(1 * ratio);
        minH = 1;
      } else {
        minW = 1;
        minH = Math.round(1 / ratio);
      }
      if (minW > maxW) {
        maxW = minW;
      }
      if (minH > maxH) {
        maxH = minH;
      }

      let arr = new Array(maxW, maxH, minW, minH);
      return arr;
    },

    resizeW() {
      let val = this.resizeWidth;
      if (this.lock) {
        let arr = this.resizeWH(this.lockRatio);
        if (val > arr[0]) {
          this.resizeWidth = arr[0];
          this.resizeHeight = arr[1];
        } else if (val < arr[2]) {
          this.resizeWidth = arr[2];
          this.resizeHeight = arr[3];
        } else {
          this.resizeWidth = val;
          this.resizeHeight = Math.round(val / this.lockRatio);
        }
      } else {
        if (val < 1) {
          this.resizeWidth = 1;
        }
        if (val > 5120) {
          this.resizeWidth = 5120;
        }
      }
    },
    resizeH() {
      let val = this.resizeHeight;
      if (this.lock) {
        let arr = this.resizeWH(this.lockRatio);
        if (val > arr[1]) {
          this.resizeWidth = arr[0];
          this.resizeHeight = arr[1];
        } else if (val < arr[3]) {
          this.resizeWidth = arr[2];
          this.resizeHeight = arr[3];
        } else {
          this.resizeWidth = Math.round(val * this.lockRatio);
          this.resizeHeight = val;
        }
      } else {
        if (val > 5120) {
          this.resizeHeight = 5120;
        }
        if (val < 20) {
          this.resizeHeight = 20;
        }
      }
    },
    changeLock() {
      this.lock = !this.lock;

      if (this.cropValue == "free" && this.lock) {
        if (this.currentTool == "crop") {
          this.lockRatio = this.cropWidth / this.cropHeight;
        } else {
          this.lockRatio = this.resizeWidth / this.resizeHeight;
        }
      }
      if (this.currentTool == "crop" && !this.lock) {
        this.cropValue = "free";
      }
    },
    resizeLimitW(e) {
      this.resizeWidth = e.target.value.replace(/^(0+)|[^\d]+/g, "");
    },
    resizeLimitH(e) {
      this.resizeHeight = e.target.value.replace(/^(0+)|[^\d]+/g, "");
    },
    numLimitW(val) {
      this.cropWidth = val.replace(/^(0+)|[^\d]+/g, "");
    },
    numLimitH(val) {
      this.cropHeight = val.replace(/^(0+)|[^\d]+/g, "");
    },
    cropW(val) {
      if (this.lock) {
        wh = this.getWH(this.lockRatio);
        if (val > wh[0]) {
          this.cropWidth = wh[0];
          this.cropHeight = wh[1];
        } else if (val < wh[2]) {
          this.cropWidth = wh[2];
          this.cropHeight = wh[3];
        } else {
          this.cropWidth = val;
          this.cropHeight = Math.round(val / this.lockRatio);
        }
      } else {
        if (val > this.selectedFile.width) {
          this.cropWidth = this.selectedFile.width;
        }
        if (val < 20) {
          this.cropWidth = 20;
        }
      }
      this.setCrop(Number(this.cropWidth), Number(this.cropHeight));
    },
    cropH(val) {
      if (this.lock) {
        wh = this.getWH(this.lockRatio);
        if (val > wh[1]) {
          this.cropWidth = wh[0];
          this.cropHeight = wh[1];
        } else if (val < wh[3]) {
          this.cropWidth = wh[2];
          this.cropHeight = wh[3];
        } else {
          this.cropWidth = Math.round(val * this.lockRatio);
          this.cropHeight = val;
        }
      } else {
        if (val > this.selectedFile.height) {
          this.cropHeight = this.selectedFile.height;
        }
        if (val < 20) {
          this.cropHeight = 20;
        }
      }
      this.setCrop(Number(this.cropWidth), Number(this.cropHeight));
    },
    getWH(ratio) {
      let maxW, maxH, minW, minH;
      if (this.selectedFile.width / this.selectedFile.height >= ratio) {
        maxW = Math.round(this.selectedFile.height * ratio);
        maxH = this.selectedFile.height;
      } else {
        maxW = this.selectedFile.width;
        maxH = Math.round(this.selectedFile.width / ratio);
      }

      if (20 * ratio > 20) {
        minW = Math.round(20 * ratio);
        minH = 20;
      } else {
        minW = 20;
        minH = Math.round(20 / ratio);
      }
      if (minW > maxW) {
        maxW = minW;
      }
      if (minH > maxH) {
        maxH = minH;
      }

      let arr = new Array(maxW, maxH, minW, minH);
      return arr;
    },

    cropValueChange(val) {
      if (val == "free" && this.lock) {
        this.lockRatio = this.cropWidth / this.cropHeight;
      }
      if (val != "free") {
        this.lock = true;
        let afterval = val;
        if (val == 9) {
          afterval = 1080 / 1920;
        }
        if (val == 16) {
          afterval = 1280 / 720;
        }
        if (val == 21) {
          afterval = 21 / 29.7;
        }
        if (val == 8) {
          afterval = 1;
        }
        if (val == 560) {
          afterval = 420 / 560;
        }
        if (val == 531) {
          afterval = 413 / 531;
        }

        this.lockRatio = afterval;
        wh = this.getWH(afterval);
        this.cropWidth = wh[0];
        this.cropHeight = wh[1];
        this.setCrop(this.cropWidth, this.cropHeight);
      }
    },
    setCrop(w, h) {
      this.selectedFile.cropangles.width = w * this.selectedFile.canvasRatio;

      this.selectedFile.cropangles.height = h * this.selectedFile.canvasRatio;
      this.selectedFile.cropangles.x = Math.round(
        ((this.selectedFile.width - w) / 2) * this.selectedFile.canvasRatio
      );
      this.selectedFile.cropangles.y = Math.round(
        ((this.selectedFile.height - h) / 2) * this.selectedFile.canvasRatio
      );
      this.reDraw();
    },
    resizeSubmit: async function () {
      resizeWRatio = this.resizeWidth / cropTempObj.width; //重绘时算好crop位置
      resizeHRatio = this.resizeHeight / cropTempObj.height;

      this.selectedFile.width = this.resizeWidth;
      this.selectedFile.height = this.resizeHeight;
      this.initCanvas(this.selectedFile.width, this.selectedFile.height);
      await this.urlCoverter(myimage.src);
      this.reDraw();
      this.historyPush("crop-resize");
      this.imgfixBefore = true;
    },

    cropSubmit: async function () {
      this.selectedFile.width = this.cropWidth;
      this.selectedFile.height = this.cropHeight;
      // cropRatio = this.selectedFile.canvasRatio //没剪切之前的缩放
      cropTempObj = JSON.parse(JSON.stringify(this.selectedFile.cropangles));
      cropTempObj.width = Math.round(
        this.selectedFile.cropangles.width /
          this.selectedFile.canvasRatio /
          resizeWRatio
      );
      cropTempObj.height = Math.round(
        this.selectedFile.cropangles.height /
          this.selectedFile.canvasRatio /
          resizeHRatio
      );

      cropLeft += Math.round(
        this.selectedFile.cropangles.x /
          this.selectedFile.canvasRatio /
          resizeWRatio
      );
      cropTop += Math.round(
        this.selectedFile.cropangles.y /
          this.selectedFile.canvasRatio /
          resizeHRatio
      );

      this.initCanvas(this.selectedFile.width, this.selectedFile.height);

      await this.urlCoverter(myimage.src);
      this.reDraw();
      this.historyPush("crop-resize");
      this.imgfixBefore = true;
    },

    //获取上传图片id
    getImageId(w, h) {
      // 将画布内容导出
      return new Promise((resolve) => {
        let canvas = document.createElement("canvas");
        canvas.width = w ? w : this.selectedFile.width;
        canvas.height = h ? h : this.selectedFile.height;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(
          myimage,
          cropLeft,
          cropTop,
          cropTempObj.width,
          cropTempObj.height,
          0,
          0,
          w ? w : this.selectedFile.width,
          h ? h : this.selectedFile.height
        );
        canvas.toBlob(async (blob) => {
          let file = blob;
          let authentications = await this.refreshAccess(
            this.selectedFile.name
          );
          let key = authentications.objects[this.selectedFile.name];
          let url = authentications["callback"]["url"];
          let callbackBody = authentications["callback"]["body"];
          let callback = {
            url: url,
            body:
              callbackBody +
              "&filename=" +
              encodeURI(this.selectedFile.name) +
              "&x:object=" +
              key +
              "&x:endpoint=" +
              authentications.endpoint +
              "&x:bucket=" +
              authentications.bucket,
          };

          this.client
            .multipartUpload(key, file, {
              cancelFlag: true,
              callback: callback,
              partSize: 500 * 1024,
              headers: {
                "Content-Disposition": encodeURI(this.selectedFile.name),
              },
            })
            .then(
              function (res) {
                if (res.data.status === 200) {
                  resolve([res.data.data.resource_id, res.data.data.url]);
                }
              }.bind(this)
            )
            .catch(() => {
              this.modalMsg = this.$t("mesage.processingError");
              this.maxLimit = true;
              this.appStatus = "finished";
              //  return;
            });
        });
      });
    },

    downloadFinished: function () {
      if (!this.isLogined) {
        this.showAccountDialog();
        return;
      }
      let hStep = this.selectedFile.hStep;
      if (hStep == -1) {
        this.downloadLink(myimage.src, this.selectedFile.name);
      } else if (hStep > -1) {
        if (this.selectedFile.historyArray[hStep].isCropResize) {
          this.urlCoverter(myimage.src, this.selectedFile.name);
        } else {
          this.downloadLink(myimage.src, this.selectedFile.name);
        }
      }
    },
    urlCoverter(url, name) {
      return new Promise((resolve) => {
        let canvas = document.createElement("canvas");
        canvas.width = this.selectedFile.width;
        canvas.height = this.selectedFile.height;
        let ctx = canvas.getContext("2d");

        ctx.drawImage(
          myimage,
          cropLeft,
          cropTop,
          cropTempObj.width,
          cropTempObj.height,
          0,
          0,
          this.selectedFile.width,
          this.selectedFile.height
        );

        if (name) {
          let url = canvas.toDataURL();
          this.downloadLink(url, name);
          resolve();
        } else {
          canvas.toBlob((blob) => {
            this.selectedFile.size = blob.size;
            resolve();
          });
        }
      });
    },
    downloadLink(link, fileName) {
      var anchor = document.createElement("a");
      anchor.id = "linkAnchor";
      anchor.href = link;
      // anchor.target = '_blank';
      if (fileName) {
        anchor.download = fileName;
      }
      document.body.appendChild(anchor);
      anchor.click();
      anchor = null;
      var anchorEle = document.getElementById("linkAnchor");
      document.body.removeChild(anchorEle);
    },

    async compressSubmit() {
      this.appStatus = "processing";
      // let picwish_api_token = Storage.get("picwish_api_token");
      let imageURL = this.selectedFile.url;
      if (this.isblue) {
        //修改过
        let resImg = await this.getImageId();
        imageURL = resImg[1];
      }
      var postData = {
        url: imageURL,
        priority: this.compress,
        format:
          this.compressFormat == "jpg" ? "jpg" : this.selectedFile.extension,
        app_type: "web",
        track: {
          product_id: 482,
          language: document.documentElement.lang || "",
        },
      };
      middleService
        .post("/tasks/document/compress", postData)
        .then(
          function (responseA) {
            if (responseA.data.status === 200) {
              this.selectedFile.status = "processing";
              this.selectedFile.task_id = responseA.data.data.task_id;
              let num = 0; //30s
              this.selectedFile.query_interval = setInterval(
                function () {
                  middleService
                    .get(
                      `/tasks/document/compress/${this.selectedFile.task_id}`
                    )
                    .then(
                      function (responseB) {
                        if (responseB.data.data.state === 1) {
                          // 处理成功
                          this.appStatus = "finished-success";
                          setTimeout(() => {
                            this.appStatus = "finished";
                          }, 2000);
                          this.selectedFile.status = "finished";
                          clearInterval(this.selectedFile.query_interval);
                          this.selectedFile.query_interval = null;
                          this.selectedFile.processed_url =
                            responseB.data.data.file;

                          this.selectedFile.size =
                            responseB.data.data.output_size;
                          this.afterSize = responseB.data.data.output_size;

                          this.selectedFile.extension =
                            this.compressFormat == "jpg"
                              ? "jpg"
                              : this.selectedFile.extension;
                          this.selectedFile.name =
                            this.selectedFile.name.substring(
                              0,
                              this.selectedFile.name.lastIndexOf(".") + 1
                            ) + this.selectedFile.extension;

                          myimage.src = responseB.data.data.file;
                          this.selectedFile.url = responseB.data.data.file;
                          myimage.onload = () => {
                            this.selectedFile.width = myimage.width;
                            this.selectedFile.height = myimage.height;
                            this.initCanvas(
                              this.selectedFile.width,
                              this.selectedFile.height,
                              true
                            );
                            this.reDraw();
                            this.historyPush();
                            myimage.onload = null;
                            this.imgfixBefore = true;
                          };
                        } else if (responseB.data.data.state < 0 || num > 30) {
                          // 处理失败
                          this.selectedFile.status = "finished";
                          clearInterval(this.selectedFile.query_interval);
                          this.selectedFile.query_interval = null;
                          this.appStatus = "finished-error";
                        } else {
                          // 处理中
                          num++;
                          this.selectedFile.process_progress =
                            responseB.data.data.progress;
                        }
                      }.bind(this)
                    )
                    .catch((err) => {
                      console.log(err);
                      this.appStatus = "finished-error";
                      clearInterval(this.selectedFile.query_interval);
                      this.selectedFile.query_interval = null;
                    });
                }.bind(this),
                1000
              );
            }
          }.bind(this)
        )
        .catch((err) => {
          console.log(err);
          this.appStatus = "finished-error";
        });
    },
  },
  filters: {
    size: function (value) {
      if (value < 1024 * 1024) {
        return (value / 1024).toFixed(2) + "kb";
      } else if (value < 1024 * 1024 * 1024) {
        return (value / 1024 / 1024).toFixed(2) + "MB";
      } else {
        return (value / 1024 / 1024 / 1024).toFixed(2) + "GB";
      }
    },
  },
};
